/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep04, resetQuotes, setStep04Renewals, getRenewalVariation, fetchTradeFairsLocations
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step04 from '../components/Step04art'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        tradeFairsLocations: state.step00.tradeFairsLocations,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep04: setStep04,
        setStep04Renewals: setStep04Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        fetchTradeFairsLocations,
    }
)(Step04)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/Step04.tsx